import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ua",
  "use": "icon-ua-usage",
  "viewBox": "0 0 32 24",
  "content": "<symbol viewBox=\"0 0 32 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ua\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V18C32 21.3137 29.3137 24 26 24H6C2.68629 24 0 21.3137 0 18V6Z\" fill=\"#FFD700\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V12H0V6Z\" fill=\"#0057B8\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol